import { render, staticRenderFns } from "./recommend_books.vue?vue&type=template&id=06be596a&scoped=true"
import script from "./recommend_books.vue?vue&type=script&lang=js"
export * from "./recommend_books.vue?vue&type=script&lang=js"
import style0 from "./recommend_books.vue?vue&type=style&index=0&id=06be596a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06be596a",
  null
  
)

export default component.exports